module.exports = __webpack_public_path__ + "img/planFamiliarColor.83901197.png";